/*
 * address (zod)
 */
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { addresses } from "./address.schema"

/* Select */
export type Address = z.infer<typeof selectAddressSchema>
export const selectAddressSchema = createSelectSchema(addresses)

/* Filters */
export type AddressFilters = z.infer<typeof addressFiltersSchema>
export const addressFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	practitionerId: z.string().optional(),
	type: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createAddressSchema = createInsertSchema(addresses).partial(
	globalCreateExclude,
)
export type CreateAddress = z.infer<typeof createAddressSchema>

/* Update */
export const updateAddressSchema = createInsertSchema(addresses)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateAddress = z.infer<typeof updateAddressSchema>
